import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Stack } from '@mui/material'
import React, { ReactNode, useState } from 'react'
import { BlankView, BlankViewImageVariants } from 'src/Components/blank-view'
import { useActiveInstallation } from 'src/Hooks'
import useInstallationPages from 'src/Hooks/use-installation-pages'
import useSelectedUserRoutes from 'src/Hooks/useSelectedUserRoutes'
import CloudRegistryKeysView from 'src/Libs/installation-rights-management/components/CloudRegistryKeysView'
import UserAccessAndInvitationsView from 'src/Libs/installation-rights-management/components/UserAccessAndInvitationsView'
import { isFlowTheme } from 'src/Libs/utils'

const HEADER_TAB_INDEX = 3

const RightsAdministrationPage: React.FC = () => {
  const { t } = useCustomTranslation()
  const [installationId, storageId] = useInstallationPages(HEADER_TAB_INDEX)
  const { userCanRead, installation, isLoading } = useActiveInstallation(true, installationId, storageId)
  const [cloudKeys, setCloudKeys] = useState<ReactNode[][]>([])
  const title = t('dashboard.rightsAdministration.title')
  useSelectedUserRoutes(title)

  if (!userCanRead && !isLoading) {
    return (
      <BlankView title={'installation.noAccess'} explanation={'installation.no-access-explanation'} imageVariant={BlankViewImageVariants.Neutral} />
    )
  }

  return (
    <Stack direction={'column'} spacing={2}>
      {userCanRead && installation && <UserAccessAndInvitationsView installation={installation} cloudKeys={cloudKeys} />}
      {userCanRead && installation && !isFlowTheme && <CloudRegistryKeysView installation={installation} setCloudKeys={setCloudKeys} />}
      {isLoading && !installation && <Box>{t('installation.waitingFor')}</Box>}
    </Stack>
  )
}

export default RightsAdministrationPage
